import { io } from 'socket.io-client';

const url = 'https://api.eprom.com.br';

const socket = io(url, { transports: ['websocket'], withCredentials: true });

export default socket;
